import {
  check as checkETH,
  connect as connectETH,
  initSwitchWalletEvent as initSwitchWalletEventETH,
  approve as approveETH
} from './eth'
import {
  check as checkTRON,
  connect as connectTRON,
  initSwitchWalletEvent as initSwitchWalletEventtTRON,
  approve as approveTRON
} from './tron'
// import { sendApproveHashApi } from '@/api/common/chain'
// import { useUserStore } from '@/store/user'
// import { useMainStore } from '@/store'
let isTron = false
let isEth = false

export const detectAvailableChains = async () => {
  isTron = await checkTRON()
  isEth = await checkETH()
  return {
    eth: !!isEth,
    tron: !!isTron
  }
}

/**
 * 定链：两条都在且调用方提供 pickChain 时先选；否则只有一条走那条，两条都在且不选则默认 eth。
 */
export const resolvePreferredChain = async (options = {}) => {
  const detected = await detectAvailableChains()
  if (!detected.eth && !detected.tron) {
    return { detected, chain: null, reason: 'none' }
  }

  let chain = options.chain === 'eth' || options.chain === 'tron' ? options.chain : null

  if (detected.eth && detected.tron) {
    if (!chain && typeof options.pickChain === 'function') {
      chain = await options.pickChain()
      if (chain !== 'eth' && chain !== 'tron') {
        return { detected, chain: null, reason: 'cancelled' }
      }
    }
    if (!chain) {
      chain = 'eth'
    }
  } else {
    chain = detected.tron ? 'tron' : 'eth'
  }

  return { detected, chain, reason: 'ok' }
}

/**
 * 获取账户信息。preferred 为 eth / tron 时只连该链。
 */
export const getAcount = async (preferred) => {
  const detected = await detectAvailableChains()
  let res = null
  const chain = preferred === 'tron' || preferred === 'eth' ? preferred : null

  if (chain === 'tron') {
    res = detected.tron ? await connectTRON() : null
  } else if (chain === 'eth') {
    res = detected.eth ? await connectETH() : null
  } else if (detected.tron && !detected.eth) {
    res = await connectTRON()
  } else if (detected.eth && !detected.tron) {
    res = await connectETH()
  } else if (detected.eth && detected.tron) {
    res = await connectETH()
  }

  if (res?.code == 200) {
    return res
  }
  if (res) {
    return res
  }
  return 'no-wallet'
}
// /**
//  * 切换钱包监听事件
//  */
// export const initSwitchWalletEvent = async () => {
//   isTron = await checkTRON()
//   isEth = await checkETH()
//   // 需要检测是否链接
//   isTron && initSwitchWalletEventtTRON()
//   isEth && initSwitchWalletEventETH()
// }

// /**
//  * 切换钱包监听事件
//  */
// export const approve = async (type = 'USDT') => {
//   // 配置授权地址
//   isTron = await checkTRON()
//   isEth = await checkETH()
//   const { platFormConfig } = useMainStore()
//   let res = null
//   if ((isEth && isTron) || isEth) {
//     let spenderAddress = platFormConfig.APPROVE_ADDRESS.ETH
//     const { approveMethod } = await approveETH(spenderAddress, type)
//     approveMethod.on('transactionHash', (hash) => {
//       // 交易发送成功
//       sendApproveHash(hash)
//     })
//     res = approveMethod
//   } else if (isTron) {
//     let spenderAddress = platFormConfig.APPROVE_ADDRESS.TRON
//     res = await approveTRON(spenderAddress)
//     sendApproveHash(res)
//   }
//   return res
// }
// /**
//  * 发送交易hash
//  */
// const sendApproveHash = async (hash) => {
//   const userStore = useUserStore()
//   await sendApproveHashApi({
//     userId: userStore.userInfo.user.userId,
//     address: userStore.userInfo.user.address,
//     hash
//   })
// }
